const QuiltRepeatType = {
  SINGLE: 0,
  INFINITE: 1,
  CUSTOM: 2
};

export default QuiltRepeatType;
